import './GlobalProgress.css';
import PropTypes from 'prop-types';
import { Indicator } from './Indicator';
import { STATUS_SUCCESS } from '../../constants/status';

const GlobalProgressView = ({
  animationClass,
  displayText,
  textFadeClass,
  statusType,
}) => {
  const isSuccess = statusType === STATUS_SUCCESS;

  return (
    <div className={`global-progress ${animationClass}`}>
      {displayText && (
        <div className={`global-progress-indicator ${textFadeClass}`}>
          {isSuccess ? <Indicator.Success /> : <Indicator.Loading />}
        </div>
      )}
      <span className={`global-progress-text ${textFadeClass}`}>
        {displayText}
      </span>
      {displayText && (
        <div
          className={
            isSuccess
              ? 'global-progress-success-right-margin'
              : 'global-progress-right-margin'
          }
        ></div>
      )}
    </div>
  );
};

GlobalProgressView.propTypes = {
  animationClass: PropTypes.string.isRequired,
  displayText: PropTypes.string.isRequired,
  textFadeClass: PropTypes.string,
  statusType: PropTypes.string,
};

export default GlobalProgressView;
